import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Route, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DispatchConfirmationDialogComponent } from 'src/app/components/dispatch/dispatch-confirmation-dialog/dispatch-confirmation-dialog.component';
import { DispatchFilterComponent } from 'src/app/components/dispatch/dispatch-filter/dispatch-filter.component';
import { DispatchItemDropzoneComponent } from 'src/app/components/dispatch/dispatch-item-dropzone/dispatch-item-dropzone.component';
import { DispatchPreferredDriversComponent } from 'src/app/components/dispatch/dispatch-preferred-drivers/dispatch-preferred-drivers.component';
import { DispatchSaveFilterDialogComponent } from 'src/app/components/dispatch/dispatch-save-filter-dialog/dispatch-save-filter-dialog.component';
import { DispatchTaskHeaderComponent } from 'src/app/components/dispatch/dispatch-task-header/dispatch-task-header.component';
import { NgbDateDispatchParserFormatter2 } from 'src/app/components/dispatch/ngb-date-custom-parser';
import { TimePickerModule } from 'src/app/components/time-picker/time-picker.module';
// import { TimeInputMaskDirective } from 'src/app/directives/time-input-mask-directive';
import { DispatchComponent } from '../../components/dispatch/dispatch.component';
import { CvvCommonModule } from '../cvv-common/cvv-common.module';
import { SharedModule } from '../shared-module/shared.module';
import { TerminalRunsModule } from '../terminal-runs/terminal-runs.module';

const routes: Route[] = [
  {
    path: 'dispatch',
    component: DispatchComponent,
    children: [ { path: 'create', component: DispatchComponent, outlet: 'side' } ]
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatIconModule,
    MatButtonModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatCardModule,
    ScrollingModule,
    NgbDropdownModule,
    NgbDatepickerModule,
    DragDropModule,
    CvvCommonModule,
    FormsModule,
    MatTooltipModule,
    ReactiveFormsModule,
    SharedModule,
    TimePickerModule,
    TerminalRunsModule,
    MatProgressBarModule,
    FontAwesomeModule
  ],
  declarations: [
    DispatchComponent,
    DispatchFilterComponent,
    DispatchItemDropzoneComponent,
    DispatchPreferredDriversComponent,
    DispatchTaskHeaderComponent,
    DispatchSaveFilterDialogComponent,
    DispatchConfirmationDialogComponent,
    // TimeInputMaskDirective
  ],
  exports: [ DispatchComponent ],
  // exports: [ DispatchComponent, TimeInputMaskDirective ],
  providers: [ { provide: NgbDateParserFormatter, useClass: NgbDateDispatchParserFormatter2 } ]
})
export class DispatchModule {}
